import { render } from "./AIDrawingPage.vue?vue&type=template&id=6fe494f8&scoped=true"
const script = {}

import "@/assets/css/cases.css?vue&type=style&index=0&id=6fe494f8&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe494f8"]])

export default __exports__